import { render, staticRenderFns } from "./session_tabs.vue?vue&type=template&id=f483165a&"
import script from "./session_tabs.vue?vue&type=script&lang=js&"
export * from "./session_tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f483165a')) {
      api.createRecord('f483165a', component.options)
    } else {
      api.reload('f483165a', component.options)
    }
    module.hot.accept("./session_tabs.vue?vue&type=template&id=f483165a&", function () {
      api.rerender('f483165a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/sessions/session_tabs.vue"
export default component.exports